import Vue from 'vue';

const state = {
    items: [],
    item: {title: ''},
    page: 1,
    perPage: 5,
};

const mutations = {
    changeNewsParams(state, items) {
        state = Object.assign(state, items)
    },
};

const getters = {
    getNewsPaginatorItems: (state, getters) => {
        return state.items.filter((item, i) => {
            if (item.image !== '')
                item.image = getters.getImageUrl + item.image;
            if ((item.city === getters.getUserCity.value || item.city === 0) && inPage(state, i))
                return parseTag(item);
        })
    },
    getNewsItemsCount: state => {
        if (state.items.length > 0)
            return Math.ceil(state.items.length / state.perPage);
        return 0;
    },
    getNewsItem() {
        return parseTag(state.item)
    },
    getNewsPageCount: state => state.page,

};

const actions = {
    changeNews({commit}, items) {
        commit('changeNewsParams', items);
    },
    setNewsItems({commit}) {
        commit('createProcess', 'news');
        Vue.http.get(this.getters.getApiUrl + 'v1/news?fitler[active]=1&sort=sort,-date_create').then(response => {
            commit('changeNewsParams', {items: response.data});
            commit('setProcessSuccess', 'news');
        }, response => {
            commit('changeNewsParams', {items: []});
            commit('setProcessFailed', {id: 'news', message: response.body.message});
        });
    },
    setNewsItem({commit}, id) {
        commit('createProcess', 'newsItem');
        Vue.http.get(this.getters.getApiUrl + 'v1/news/' + id).then(response => {
            commit('changeNewsParams', {item: response.data});
            commit('setProcessSuccess', 'newsItem');
        }, response => {
            commit('changeNewsParams', {item: {title: ''}});
            commit('setProcessFailed', {id: 'newsItem', message: response.body.message});
        });
    },
};

export default {
    state,
    mutations,
    getters,
    actions,
}

function inPage(state, i) {
    return (i >= (state.page - 1) * state.perPage && i < (state.page - 1) * state.perPage + state.perPage)
}

function parseTag(item) {
    if (item.description === undefined)
        return item;
    let description = item.description;
    item.description = item.description.replace(/#перевод#/ug, "<br>");
    item.description = item.description.replace(/#i#/ug, "<i>");
    item.description = item.description.replace(/#_i#/ug, "</i>");
    item.description = item.description.replace(/#b#/ug, "<b>");
    item.description = item.description.replace(/#_b#/ug, "</b>");
    for (let n = 0; n < 10; n++) {
        let result = /https*:[A-z0-9\/\._\-]+/g.exec(description);
        if (result !== null) {
            item.description = item.description.replace(result[0], "<a href='" + result[0] + "' target='_blank'>" + result[0] + '</a>')
            description = description.replace(result[0], '');
        }
    }
    return item;
}



// WEBPACK FOOTER //
// ./src/store/modules/news.js